import React from "react"
import { useExhibitorDataState } from "../../../globalStates/ExhibitorDataState"
import { useLanguageState } from "../../../globalStates/LanguageState"
import Page from "../../../components/Page"
import NewsSection from "../NewsSection"

const OrganizerNewsPage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const newsStates = useExhibitorDataState().getOrganizerNews()

    return (
        <Page
            title={branding.configuration.organizerNewsPage.pageTitle}
            description={branding.configuration.organizerNewsPage.pageDescription}
        >
            {newsStates?.map((newsState, index) => (
                <NewsSection
                    key={newsState.id.get()}
                    newsState={newsState}
                    index={index}
                    categoryWhitelist={branding.configuration.organizerNewsPage.categoryWhitelist}
                />
            ))}
        </Page>
    )
}

export default OrganizerNewsPage
